module.exports = __webpack_public_path__ + "static/media/Logo_Negativo.3450234b.svg";